/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1TutoraiUsagePersonidLimit202,
  PutApiV1TutoraiUsagePersonidLimit400,
  PutApiV1TutoraiUsagePersonidLimit401,
  PutApiV1TutoraiUsagePersonidLimit500,
  PutApiV1TutoraiUsagePersonidLimitMutationRequest,
  PutApiV1TutoraiUsagePersonidLimitMutationResponse,
  PutApiV1TutoraiUsagePersonidLimitPathParams,
} from "../../types/tutorAIUsageController/PutApiV1TutoraiUsagePersonidLimit.ts";
import { tutorAITokenLimitResultViewModelSchema } from "../tutorAITokenLimitResultViewModelSchema.ts";
import { tutorAIUpdateTokenLimitViewModelSchema } from "../tutorAIUpdateTokenLimitViewModelSchema.ts";

export const putApiV1TutoraiUsagePersonidLimitPathParamsSchema = z.object({
  personId: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimitPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1TutoraiUsagePersonidLimit202Schema = z.lazy(
  () => tutorAITokenLimitResultViewModelSchema,
) as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimit202>;

/**
 * @description Valores inválidos (limite negativo).
 */
export const putApiV1TutoraiUsagePersonidLimit400Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimit400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1TutoraiUsagePersonidLimit401Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimit401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1TutoraiUsagePersonidLimit500Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimit500>;

export const putApiV1TutoraiUsagePersonidLimitMutationRequestSchema = z.lazy(
  () => tutorAIUpdateTokenLimitViewModelSchema,
) as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimitMutationRequest>;

export const putApiV1TutoraiUsagePersonidLimitMutationResponseSchema = z.lazy(
  () => putApiV1TutoraiUsagePersonidLimit202Schema,
) as unknown as ToZod<PutApiV1TutoraiUsagePersonidLimitMutationResponse>;
